import { FormControl } from '@angular/forms';

export class CustomValidators {

  static emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  static alphaRegex = /^[a-zA-Z\u00C0-\u00FF\s]*$/;

  static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    const config = {
      required: { message: 'REQUIRED', param: '' },
      email: { message: 'INVALIDEMAIL', param: '' },
      invalidPassword: { message: 'INVALIDPASSWORD', param: '' },
      minlength: { message: 'MINIMUNLENGTH', param: validatorValue.requiredLength },
      requiredWith: { message: 'REQUIRED', param: validatorValue.field },
      invalidDocument: { message: 'INVALIDDOCUMENT', param: '' },
      noAlphanumeric: { message: 'NOALPHANUMERIC', param: '' },
      notValidCharacters: { message: 'NOTVALIDCHARACTERS', param: '' }
    };

    return config[validatorName];
  }

  static passwordValidator(control: FormControl) {
    // {6,100}           - Assert password is between 6 and 100 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    if (control.value && !control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
      return { invalidPassword: true };
    } else {
      return null;
    }
  }

  static documentValidator(control: FormControl) {
    if (control.value && !control.value.match(/(^([X-Zx-z]{1})([-]?)(\d{7})([-]?)([A-Za-z]{1})$)|(^(\d{8})([-]?)([A-Za-z]{1})$)/)) {
      return { invalidDocument: true };
    } else {
      return null;
    }
  }

  static passportValidator(control: FormControl) {
    if (control.value && !control.value.match(/^(?!^0+$)[a-zA-Z0-9]{6,9}$/)) {
      return { invalidDocument: true };
    } else {
      return null;
    }
  }

  static documentOrPassportValidator(control: FormControl) {
    if (control.value && (CustomValidators.documentValidator(control) && CustomValidators.passportValidator(control))) {
      return { invalidDocument: true };
    } else {
      return null;
    }

  }

  static requiredWith(field: string) {
    return (control: FormControl) => {
      if (control.parent?.get(field).value && !control.value) {
        return { requiredWith: true };
      } else {
        return null;
      }
    };
  }

  static alphanumeric(control: FormControl) {
    if (control.value && !control.value.match(/^[a-zA-Z0-9]*$/)) {
      return { noAlphanumeric: true };
    } else {
      return null;
    }
  }

  static validCharacters(control: FormControl) {
    if (control.value && control.value.match(/(¡|!|\(|\)|~|\?|\^|\[|\]|\+|\*|\_|\{|\}|\;|\,|\/)/)) {
      return { notValidCharacters: true };
    } else {
      return null;
    }
  }

  static validCandidateIdCharacters(control: FormControl) {
    if (control.value && control.value.match(/(¡|!|\(|\)|~|\?|\^|\[|\]|\+|\*|\-|\{|\}|\;|\,|\/)/)) {
      return { notValidCharacters: true };
    } else {
      return null;
    }
  }

}
